import { EventBus } from 'primevue/utils';

var ConfirmationEventBus = EventBus();

export { ConfirmationEventBus as default };
